"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZappEventName = void 0;
var ZappEventName;
(function (ZappEventName) {
    ZappEventName["ADDED_ADDRESS"] = "added_address";
    ZappEventName["ADDED_ADDRESS_OUT_OF_AREA"] = "added_address_out_of_area";
    ZappEventName["ADDED_PRODUCT_TO_CART"] = "added_product_to_cart";
    ZappEventName["ADDED_RECOMMENDED_PRODUCT_TO_CART"] = "added_recommended_product_to_cart";
    ZappEventName["ADDED_ORDERED_PRODUCT_TO_CART"] = "added_ordered_product_to_cart";
    ZappEventName["AUTHORIZED_APP_TRACKING"] = "authorized_app_tracking";
    ZappEventName["CLICKED_GO_TO_DIFFERENT_ISSUE_FEEDBACK"] = "clicked_go_to_different_issue_feedback";
    ZappEventName["CLICKED_GO_TO_HOME"] = "clicked_go_to_home";
    ZappEventName["CLICKED_GO_TO_HELP_CENTER"] = "clicked_go_to_help_center";
    ZappEventName["CLICKED_SUBMIT_ADDITIONAL_FEEDBACK"] = "clicked_submit_additional_feedback";
    ZappEventName["CLOSED_APP"] = "closed_app";
    ZappEventName["CHANGED_APP_STATE"] = "changed_app_state";
    ZappEventName["CLICKED_BANNER"] = "clicked_banner";
    ZappEventName["CLICKED_COPY_REFERRAL_CODE"] = "clicked_copy_referral_code";
    ZappEventName["CLICKED_REORDER_PRODUCTS"] = "clicked_reorder_products";
    ZappEventName["CLICKED_SHARE_REFERRAL_CODE"] = "clicked_share_referral_code";
    ZappEventName["CLICKED_SHARE_REFERRAL_QRCODE"] = "clicked_share_referral_qrcode";
    ZappEventName["CLICKED_TRENDING_SEARCH_QUERY"] = "clicked_trending_search_query";
    ZappEventName["CONFIRMED_PUSH_PROMPT"] = "confirmed_push_prompt";
    ZappEventName["CONFIRMED_PUSH_PROMPT_ON_ORDER"] = "confirmed_push_prompt_on_order";
    ZappEventName["CONFIRMED_RESTRICTION_MODAL"] = "confirmed_restriction_modal";
    ZappEventName["CONFIRMED_WAITING_CUSTOMER"] = "confirmed_waiting_customer";
    ZappEventName["DELETED_ADDRESS"] = "deleted_address";
    ZappEventName["DENIED_APP_TRACKING"] = "denied_app_tracking";
    ZappEventName["EDITED_ADDRESS"] = "edited_address";
    ZappEventName["GO_BACK_TO_PREVIOUS_MODAL"] = "go_back_to_previous_modal";
    ZappEventName["OPENED_ADDITIONAL_COMMENTS_MODAL"] = "opened_additional_comments_modal";
    ZappEventName["OPENED_APP"] = "opened_app";
    ZappEventName["OPENED_APP_RATING_DIALOG"] = "opened_app_rating_dialog";
    ZappEventName["OPENED_APP_FROM_SHARE_PRODUCT"] = "opened_app_from_share_product";
    ZappEventName["OPENED_BASKET"] = "opened_basket";
    ZappEventName["OPENED_BASKET_SUMMARY"] = "opened_basket_summary";
    ZappEventName["OPENED_CATEGORY"] = "opened_category";
    ZappEventName["OPENED_CREDIT_LOGS"] = "opened_credit_logs";
    ZappEventName["OPENED_CREDIT_MODAL"] = "opened_credit_modal";
    ZappEventName["OPENED_DOES_NOT_QUALIFY_FOR_CREDIT_ISSUE_IS_NOT_URGENT_MODAL"] = "opened_does_not_qualify_for_credit_issue_is_not_urgent_modal";
    ZappEventName["OPENED_DOES_NOT_QUALIFY_FOR_CREDIT_ISSUE_IS_URGENT_MODAL"] = "opened_does_not_qualify_for_credit_issue_is_urgent_modal";
    ZappEventName["OPENED_DIFFERENT_ISSUE_FEEDBACK_MODAL"] = "opened_different_issue_feedback_modal";
    ZappEventName["OPENED_HELP_CENTER"] = "opened_help_center";
    ZappEventName["OPENED_HELP_CHAT"] = "opened_help_chat";
    ZappEventName["OPENED_HELP_CALL"] = "opened_help_call";
    ZappEventName["OPENED_HELP_FAQ"] = "opened_help_faq";
    ZappEventName["OPENED_HOME"] = "opened_home";
    ZappEventName["OPENED_LIVE_TRACKING"] = "opened_live_tracking";
    ZappEventName["OPENED_MENU"] = "opened_menu";
    ZappEventName["OPENED_MISSING_ITEM_MODAL"] = "opened_missing_item_modal";
    ZappEventName["OPENED_NEGATIVE_FEEDBACK_MODAL"] = "opened_negative_feedback_modal";
    ZappEventName["OPENED_ORDER"] = "opened_order";
    ZappEventName["OPENED_ORDER_RATING_MODAL"] = "opened_order_rating_modal";
    ZappEventName["OPENED_ORDERED_PRODUCTS_LIST"] = "opened_ordered_products_list";
    ZappEventName["OPENED_POSITIVE_FEEDBACK_MODAL"] = "opened_positive_feedback_modal";
    ZappEventName["OPENED_PRODUCT"] = "opened_product";
    ZappEventName["OPENED_PRODUCT_ZOOM"] = "opened_product_zoom";
    ZappEventName["OPENED_PUSH_PROMPT"] = "opened_push_prompt";
    ZappEventName["OPENED_PUSH_PROMPT_ON_ORDER"] = "opened_push_prompt_on_order";
    ZappEventName["OPENED_QUALITY_ISSUE_MODAL"] = "opened_quality_issue_modal";
    ZappEventName["OPENED_QUALIFIES_FOR_CREDIT_MODAL"] = "opened_qualifies_for_credit_modal";
    ZappEventName["OPENED_REFERRAL"] = "opened_referral";
    ZappEventName["OPENED_REFERRAL_FROM_DEEP_LINK"] = "opened_referral_from_deep_link";
    ZappEventName["OPENED_RESTRICTION_MODAL"] = "opened_restriction_modal";
    ZappEventName["OPENED_RIDER_TIPS"] = "opened_rider_tips";
    ZappEventName["OPENED_RIDER_TIPS_MODAL"] = "opened_rider_tips_modal";
    ZappEventName["OPENED_WAITING_CUSTOMER"] = "opened_waiting_customer";
    ZappEventName["PURCHASE_FAILED"] = "purchase_failed";
    ZappEventName["PURCHASE_FIRST_SUCCESSFUL"] = "purchase_first_successful";
    ZappEventName["PURCHASE_SUCCESSFUL"] = "purchase_successful";
    ZappEventName["PRODUCT_PINCH_TO_ZOOM"] = "product_pinch_to_zoom";
    ZappEventName["REJECTED_ADDITIONAL_COMMENTS_MODAL"] = "rejected_additional_comments_modal";
    ZappEventName["REJECTED_MISSING_ITEM_MODAL"] = "rejected_missing_item_modal";
    ZappEventName["REJECTED_NEGATIVE_FEEDBACK_MODAL"] = "rejected_negative_feedback_modal";
    ZappEventName["REJECTED_ORDER_RATING_MODAL"] = "rejected_order_rating_modal";
    ZappEventName["REJECTED_POSITIVE_FEEDBACK_MODAL"] = "rejected_positive_feedback_modal";
    ZappEventName["REJECTED_PUSH_PROMPT"] = "rejected_push_prompt";
    ZappEventName["REJECTED_PUSH_PROMPT_ON_ORDER"] = "rejected_push_prompt_on_order";
    ZappEventName["REJECTED_QUALITY_ISSUE_MODAL"] = "rejected_quality_issue_modal";
    ZappEventName["REJECTED_RESTRCICTION_MODAL"] = "rejected_restriction_modal";
    ZappEventName["REJECTED_RIDER_TIPS"] = "rejected_rider_tips";
    ZappEventName["REJECTED_RIDER_TIPS_MODAL"] = "rejected_rider_tips_modal";
    ZappEventName["REMOVED_PRODUCT_FROM_CART"] = "removed_product_from_cart";
    ZappEventName["REPORT_AN_ISSUE"] = "report_an_issue";
    ZappEventName["VIEWED_RECOMMENDED_PRODUCT"] = "viewed_recommended_product";
    ZappEventName["SKIPPED_RIDER_TIPS_MODAL"] = "skipped_rider_tips_modal";
    ZappEventName["SIGNED_IN"] = "signed_in";
    ZappEventName["SIGNED_OUT"] = "signed_out";
    ZappEventName["SIGNED_UP"] = "signed_up";
    ZappEventName["SIGNED_UP_WITH_REFERRAL"] = "signed_up_with_referral";
    ZappEventName["STARTED_SEARCH"] = "started_search";
    ZappEventName["SHARE_BUTTON_CLICKED"] = "share_button_clicked";
    ZappEventName["COMPLETED_SEARCH"] = "completed_search";
    ZappEventName["ENDED_SEARCH_SESSION"] = "ended_search_session";
    ZappEventName["SUBMITTED_ADDITIONAL_COMMENTS_MODAL"] = "submitted_additional_comments_modal";
    ZappEventName["SUBMITTED_DIFFERENT_ISSUE_FEEDBACK_MODAL"] = "submitted_different_issue_feedback_modal";
    ZappEventName["SUBMITTED_MISSING_ITEM_MODAL"] = "submitted_missing_item_modal";
    ZappEventName["SUBMITTED_NEGATIVE_FEEDBACK_MODAL"] = "submitted_negative_feedback_modal";
    ZappEventName["SUBMITTED_ORDER_RATING"] = "submitted_order_rating";
    ZappEventName["SUBMITTED_POSITIVE_FEEDBACK_MODAL"] = "submitted_positive_feedback_modal";
    ZappEventName["SUBMITTED_QUALITY_ISSUE_MODAL"] = "submitted_quality_issue_modal";
    ZappEventName["SUBMITTED_REFERRAL_CODE"] = "submitted_referral_code";
    ZappEventName["SUBMITTED_RIDER_TIPS"] = "submitted_rider_tips";
    ZappEventName["VIEWED_PRODUCT"] = "viewed_product";
    ZappEventName["JUMPED_TO_RECOMMENDED_PRODUCTS"] = "jumped_to_recommended_products";
    ZappEventName["VIEWED_HOME_CAROUSEL"] = "viewed_home_carousel";
    ZappEventName["ABANDONED_BASKET"] = "abandoned_basket";
})(ZappEventName = exports.ZappEventName || (exports.ZappEventName = {}));
